import styled, { css } from 'styled-components';

const base = css`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  text-decoration: none;
  padding: 15px 38px;
  clip-path: polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%);
  @media (max-width: 480px) { padding: 13px 28px; font-size: 12px; }
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: none;
  outline: none;
`;

export const ButtonPrimary = styled.a`
  ${base}
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.blue} 0%, ${({ theme }) => theme.colors.purple} 100%);
  color: #fff;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.18), transparent);
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: ${({ theme }) => theme.shadows.blueGlow};
    &::before { opacity: 1; }
  }

  &:active { transform: translateY(-1px); }
`;

export const ButtonOutline = styled.a`
  ${base}
  background: transparent;
  color: rgba(255,255,255,0.85);
  border: 1px solid rgba(255,255,255,0.18);

  &:hover {
    border-color: ${({ theme }) => theme.colors.blue};
    color: ${({ theme }) => theme.colors.blue};
    box-shadow: 0 0 24px rgba(0,163,255,0.18);
    background: rgba(0,163,255,0.05);
  }
`;

export const ButtonGhost = styled.a`
  ${base}
  background: transparent;
  color: ${({ theme }) => theme.colors.blue};
  padding: 0;
  clip-path: none;
  letter-spacing: 0.18em;
  font-size: 12px;

  &::after {
    content: '→';
    transition: transform 0.3s;
  }

  &:hover::after { transform: translateX(6px); }
`;
